export default __webpack_public_path__ + "static/media/5_3.9513ae5b.png";